import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Button, Icon } from 'gu-ui-kit'
import styles from 'components/Filters/FilterPanel/subcomponents/FilterDropdownButton/filter-dropdown-buttton.module.scss'
import OutsideClickHandler from 'react-outside-click-handler'
import pickBy from 'lodash/pickBy'
import FilterDropdown from 'components/Filters/FilterPanel/subcomponents/Dropdown'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

const FilterDropdownButton = ({ filterManager }) => {
  const { filters, configuration } = filterManager
  const dropDownRef = useRef()
  const dropdownFilters = useMemo(
    () => pickBy(configuration, (item) => item.position === 'dropdown') ?? {},
    [configuration],
  )

  const [visibleDropdown, setVisibleDropdown] = useState(false)

  useEffect(() => {
    setVisibleDropdown(false)
  }, [filters])

  useEffect(() => {
    if (visibleDropdown) {
      global.addEventListener('click', handleClickAway)
    }

    return () => {
      global.removeEventListener('click', handleClickAway)
    }
  }, [visibleDropdown])

  useEffect(() => {
    return () => {
      global.removeEventListener('click', handleClickAway)
    }
  }, [])

  const handleClick = useCallback(
    (e) => {
      e.stopPropagation()
      setVisibleDropdown(true)
    },
    [setVisibleDropdown],
  )

  const handleClickAway = useCallback(
    (e) => {
      e.stopPropagation()
      if (!dropDownRef.current) return

      if (
        !e.target.closest(
          '.' + dropDownRef.current.className.split(' ').join('.'),
        )
      ) {
        setVisibleDropdown(false)
      }
    },
    [dropDownRef],
  )

  if (isEmpty(dropdownFilters)) {
    return null
  }

  return (
    <div>
      <Button
        variant={'secondary'}
        size={'l'}
        grey
        onClick={handleClick}
        noLabel
        startIcon={
          <Icon
            name={'filter'}
            size={'m'}
            color={visibleDropdown ? 'Interface-GU-Tertiary' : 'Label-Fifth'}
          />
        }
      />

      {!!visibleDropdown && (
        <OutsideClickHandler onOutsideClick={handleClickAway}>
          <div className={styles['filter-dropdown__wrapper']}>
            <div
              className={styles['filter-dropdown__dropdown-container']}
              ref={dropDownRef}
            >
              {Object.keys(dropdownFilters).length > 0 ? (
                <FilterDropdown
                  filterManager={filterManager}
                  dropdownFilters={Object.entries(dropdownFilters).map(
                    ([key, values]) => ({
                      key,
                      ...values,
                    }),
                  )}
                />
              ) : null}
            </div>
          </div>
        </OutsideClickHandler>
      )}
    </div>
  )
}

export default FilterDropdownButton

FilterDropdownButton.propTypes = {
  filterManager: PropTypes.object,
}
